import { render, staticRenderFns } from "./component-c57cd1bd.vue?vue&type=template&id=2dde470f&scoped=true&"
import script from "./component-c57cd1bd.vue?vue&type=script&lang=js&"
export * from "./component-c57cd1bd.vue?vue&type=script&lang=js&"
import style0 from "./component-c57cd1bd.vue?vue&type=style&index=0&id=2dde470f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dde470f",
  null
  
)

export default component.exports